import React from "react";
import { LegalShell, H2, P, UL } from "@/components/LegalShell";

export default function DataDeletion() {
  return (
    <LegalShell title="Data Deletion" updated="June 2026" testid="data-deletion-page">
      <P>You can ask us to delete the personal data associated with your iYeneh Connect account at any time. This page explains how, in line with our Privacy Policy and the requirements of platforms such as Facebook and Google.</P>

      <H2>How to Request Deletion</H2>
      <UL>
        <li><strong>Email:</strong> Send a request from your account email to <a className="text-white underline" href="mailto:support@iyeneh.com?subject=Data%20Deletion%20Request">support@iyeneh.com</a> with the subject "Data Deletion Request".</li>
        <li><strong>WhatsApp:</strong> Message our support team at <a className="text-white underline" href="https://wa.me/12029403399" target="_blank" rel="noreferrer">+1 202 940 3399</a> and ask to delete your account.</li>
        <li><strong>In app:</strong> Open your Profile and use the account removal option, or contact support from within the app.</li>
      </UL>
      <P>To protect your account, we may ask you to verify your identity (for example, by confirming the mobile number or email on file) before we proceed.</P>

      <H2>What Gets Deleted</H2>
      <P>Once verified, we delete or irreversibly anonymize your personal information, including your profile details, contact information, marketing preferences and any third-party sign-in identifiers (such as your Facebook or Google account ID) connected to iYeneh.</P>

      <H2>What We May Retain</H2>
      <P>We may retain limited records where the law requires it — for example, transaction and billing records for tax, accounting, fraud-prevention and regulatory purposes. Such records are kept only for the period required and are not used for marketing.</P>

      <H2>Timeframe</H2>
      <P>We aim to complete verified deletion requests within 30 days and will confirm by email once done.</P>

      <H2>Contact</H2>
      <P>For any question about data deletion, email <a className="text-white underline" href="mailto:support@iyeneh.com">support@iyeneh.com</a>.</P>
    </LegalShell>
  );
}
